/** Erro de uma pergunta recusada antes de começar (sem crédito, já respondendo...). */
export class ErroDaPergunta extends Error {
  constructor(mensagem, { status, tipo } = {}) {
    super(mensagem);
    this.status = status;
    this.tipo = tipo;
  }
}
